import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "20",
      height: "23",
      x: "5",
      y: "3.5",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("rect", {
      width: "13",
      height: "6",
      x: "8.5",
      y: "7",
      rx: "1"
    }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "11",
      cy: "19",
      r: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "19",
      cy: "19",
      r: "2"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }